import classNames from 'classnames'
import { ReactNode, useState } from 'react'
import { Button } from 'src/Components'
import Chevron, {
  DOWN,
  UP,
} from 'src/Components/buyers/Global/ZipCodeModal/MapListToggle/Chevron'

import styles from './ListViewFilterViewSpacingWrapper.module.scss'

interface ListViewFilterViewSpacingWrapperProps {
  children: ReactNode
}
export const ListViewFilterViewSpacingWrapper = ({
  children,
}: ListViewFilterViewSpacingWrapperProps) => {
  const [isMobileViewExpanded, setIsMobileViewExpanded] = useState(false)

  return (
    <div
      className={classNames({
        [styles.wrapper]: true,
        [styles.mobileListViewExpanded]: isMobileViewExpanded,
      })}
    >
      <Button
        id='mobileScrollButton'
        className={styles.mobileScroll}
        onClick={() => setIsMobileViewExpanded(!isMobileViewExpanded)}
        data-qa='mapListToggle'
        aria-hidden='true'
        minimal
      >
        <Chevron direction={isMobileViewExpanded ? DOWN : UP} />
      </Button>
      <div className={styles.childrenWrapper}>{children}</div>
    </div>
  )
}
